import { render, staticRenderFns } from "./_DoctorWorkspaceClinic.vue?vue&type=template&id=c307d20a&scoped=true"
import script from "./_DoctorWorkspaceClinic.vue?vue&type=script&lang=js"
export * from "./_DoctorWorkspaceClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c307d20a",
  null
  
)

export default component.exports